import React from 'react';
import { findDOMNode } from 'react-dom';
import { TweenLite, TimelineLite } from 'gsap';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';

export default {

	setVars(BusinessEthernetForm) {
		this.node = findDOMNode(BusinessEthernetForm);
		this.loader = this.node.querySelector('.loader');
		this.error = this.node.querySelector('.error-msg');
		this.btn = this.node.querySelector('.fibre-submit-btn');
		this.disclaimer = this.node.querySelector('.disclaimer1');
		// On Success:
		this.animateOut = this.node.querySelector('.animate-out');
		this.plansContainer = this.node.querySelector('.plans-container');
		this.planButtons = this.node.querySelector('.plans-container .buttons');
		this.plans = this.node.querySelectorAll('.plans-container .plans .plan');
		this.notice = this.node.querySelector('.notice');
	},
    
    reset(BusinessEthernetForm) {
        this.setVars(BusinessEthernetForm);

        this.loader.style.display = 'none';
		this.btn.style.display = 'block';

        let labels = [...this.node.getElementsByClassName('input__label')],
            graphics = [...this.node.getElementsByClassName('graphic--nao')],
            formRows = [...this.node.getElementsByClassName('form-row')];

        labels.map(item => {
            item.style.color = '#004346';
        });

        graphics.map(item => {
            item.style.stroke = '#004346';
        });

        formRows.map(item => {
            item.style.display = 'block';
        });
    },

    showLoader(BusinessEthernetForm) {
		this.setVars(BusinessEthernetForm);

		this.btn.style.display = 'none';
		this.error.style.display = 'none';
		this.plansContainer.style.visibility = 'hidden';
        this.loader.style.display = 'block';
    },

    showSuccess(BusinessEthernetForm) {
		this.setVars(BusinessEthernetForm);
		let tl = new TimelineLite();

		this.loader.style.display = 'none';
		this.error.style.display = 'none';
		this.btn.style.display = 'none';
		this.disclaimer.style.display = 'none';

		tl.to(this.animateOut, 0.5, {y: -300, opacity: 0});
		tl.addLabel('reset', 0.5);
		tl.set(this.animateOut, {display: 'none'}, 'reset');
		tl.add(() => {
			this.plansContainer.style.display = 'block';
			this.plansContainer.style.visibility = 'visible';
		});
		tl.staggerFromTo(this.plans, 0.75, {y: 50, opacity: 0}, {y: 0, opacity: 1, ease: Power2.easeOut}, 0.1);
		tl.fromTo(this.planButtons, 0.25, {opacity: 0, y: -50}, {opacity: 1, y: 0});
		tl.fromTo(this.notice, 0.3, {opacity: 0, scale: 0.5}, {opacity: 1, scale: 1, delay: 1.5});
    },

    showErrors(BusinessEthernetForm) {
		this.setVars(BusinessEthernetForm);

        this.loader.style.display = 'none';
        this.error.style.display = 'block';
		this.btn.style.display = 'block';
		[...this.node.getElementsByClassName('form-row')].map(item => {
			item.style.display = 'block';
		});
    },

	showError(BusinessEthernetForm, selector) {
		this.setVars(BusinessEthernetForm);
		let tl = new TimelineLite(),
			container = this.node.querySelector(selector);

		this.loader.style.display = 'none';
		this.btn.style.display = 'block';
		this.node.querySelector('form').style.visibility = 'hidden';
		tl.set(container, {display: 'flex', opacity: 0});
		tl.to(container, 0.5, {opacity: 1});
	},

	closeError(BusinessEthernetForm, selector) {
		this.setVars(BusinessEthernetForm);
		let tl = new TimelineLite(),
			container = this.node.querySelector(selector);

		this.node.querySelector('form').style.visibility = 'visible';
		tl.to(container, 0.25, {opacity: 0});
		tl.set(container, {display: 'none', opacity: 1});
	},

	setActive(target) {
		[...document.querySelectorAll('.speed-btn')].map(item => {
			item.classList.remove('active');
		});

		target.classList.add('active');
	}

}


// WEBPACK FOOTER //
// ./resources/assets/js/forms/InternetFormContainer/animations.js